import { render, staticRenderFns } from "./CustomerCrmHome.vue?vue&type=template&id=bbe02532&"
import script from "./CustomerCrmHome.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports